// Numeral handling (DESIGN_SYSTEM §4.6). Display is always Latin digits (D-013). Every numeric,
// phone and money input accepts Devanagari digits (०–९) and normalises them to Latin.

const DEVANAGARI_ZERO = 0x0966;

/** Replaces Devanagari digits U+0966–U+096F with ASCII 0–9. Other characters are untouched. */
export function normalizeDigits(input: string): string {
  let out = "";
  for (const ch of input) {
    const cp = ch.codePointAt(0) ?? 0;
    out += cp >= DEVANAGARI_ZERO && cp <= DEVANAGARI_ZERO + 9 ? String(cp - DEVANAGARI_ZERO) : ch;
  }
  return out;
}

/**
 * Indian (lakh/crore) grouping of a string of ASCII digits: the last three digits, then pairs.
 * Works on any length, so it is safe for live input that exceeds Number.MAX_SAFE_INTEGER.
 */
export function groupIndian(digits: string): string {
  if (!/^\d+$/.test(digits)) throw new Error("groupIndian expects ASCII digits only");
  const trimmed = digits.replace(/^0+(?=\d)/, "");
  if (trimmed.length <= 3) return trimmed;
  const last3 = trimmed.slice(-3);
  let rest = trimmed.slice(0, -3);
  const parts: string[] = [];
  while (rest.length > 2) {
    parts.unshift(rest.slice(-2));
    rest = rest.slice(0, -2);
  }
  if (rest) parts.unshift(rest);
  return `${parts.join(",")},${last3}`;
}
